
import request from '@/utils/request'

export function uploadZip (data) {
    request.defaults.timeout = 180000;
    return request({
      url: '/meddra/uploadNewVersion',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).finally( 
      //issue 272
      () =>  { request.defaults.timeout = 180000 }
      //issue 272
    )
  }